import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { ButtonTertiary, IconX } from '@spotify-internal/encore-web';
import styled from 'styled-components';
const FullscreenDialog = styled.dialog `
  width: 90%;
  height: 90%;
  &::backdrop {
    background-color: rgba(0, 0, 0, 0.65);
  }

  border: 0;
  background: transparent;

  button[aria-label='close button']:hover {
    color: initial;
    opacity: 50%;
  }
`;
const CloseButton = styled(ButtonTertiary) `
  color: white;
  position: fixed;
  right: 20px;
  top: 20px;
`;
export const Dialog = ({ show, onClose, children }) => {
    const [isShowing, setIsShowing] = useState(show);
    const dialogRef = useRef(null);
    const handleClose = useCallback(() => {
        var _a;
        setIsShowing(false);
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.close();
        onClose();
    }, [onClose]);
    const handleEscapeKey = useCallback((e) => {
        if (e.key === 'Escape') {
            handleClose();
        }
    }, [handleClose]);
    useEffect(() => {
        var _a;
        (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', handleEscapeKey);
    }, [handleEscapeKey]);
    useEffect(() => {
        var _a;
        if (!isShowing && show) {
            (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.showModal();
            setIsShowing(true);
        }
    }, [isShowing, show]);
    return (React.createElement(FullscreenDialog, { ref: dialogRef, onClose: handleClose, onClick: handleClose },
        React.createElement(CloseButton, { "aria-label": "close button", iconOnly: IconX, onClick: handleClose, "data-testid": "chat-box-close-button" }),
        children));
};
//# sourceMappingURL=Dialog.js.map